import { render, staticRenderFns } from "./Investidores.vue?vue&type=template&id=1ff24134&scoped=true"
import script from "./Investidores.vue?vue&type=script&lang=js"
export * from "./Investidores.vue?vue&type=script&lang=js"
import style0 from "./Investidores.vue?vue&type=style&index=0&id=1ff24134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff24134",
  null
  
)

export default component.exports